/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { Column, Divider } from '../../tracking-list';
import { ColumnCommonProps } from '../survey-question-list';
import { BulkActionToolbarSelectedUtrv } from './BulkActionToolbar';

interface ColumnSelectboxProps extends ColumnCommonProps {
  isSelected: boolean;
  toggleSelectQuestion: (utrv: BulkActionToolbarSelectedUtrv) => void;
}

export const ColumnSelectbox = (props: ColumnSelectboxProps) => {
  const { question, isSelected, toggleSelectQuestion } = props;
  const { valueType, valueValidation } = question;
  if (!question.utrv) {
    return null;
  }

  const utrv = question.utrv;

  return (
    <>
      <Divider />
      <Column className='question-list__select-box' >
        <Button color='link' onClick={() => toggleSelectQuestion({...utrv, valueType, valueValidation })} className='p-0'>
          <i className={`${isSelected ? 'fa-solid fa-square-check text-ThemeAccentMedium' : 'fa-light fa-square text-ThemeNeutralsDark'}`} />
        </Button>
      </Column>
    </>
  );
}
